export function audioBufferToWav(
  buffer: AudioBuffer,
  sampleRate: number = 22050,
  bitDepth: number = 32
): Blob {
  const numChannels = buffer.numberOfChannels;
  const length = buffer.length * numChannels * (bitDepth / 8);
  const headerSize = 44;
  const bufferArray = new ArrayBuffer(headerSize + length);
  const view = new DataView(bufferArray);

  const writeString = (view: DataView, offset: number, string: string) => {
    for (let i = 0; i < string.length; i++) {
      view.setUint8(offset + i, string.charCodeAt(i));
    }
  };

  writeString(view, 0, "RIFF");
  view.setUint32(4, 36 + length, true);
  writeString(view, 8, "WAVE");
  writeString(view, 12, "fmt ");
  view.setUint16(16, 16, true);
  view.setUint16(20, bitDepth === 32 ? 3 : 1, true);
  view.setUint16(22, numChannels, true);
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, sampleRate * numChannels * (bitDepth / 8), true);
  view.setUint16(32, numChannels * (bitDepth / 8), true);
  view.setUint16(34, bitDepth, true);
  writeString(view, 36, "data");
  view.setUint32(40, length, true);

  for (let channel = 0; channel < numChannels; channel++) {
    const data = buffer.getChannelData(channel);
    for (let i = 0; i < buffer.length; i++) {
      const offset = headerSize + (i * numChannels + channel) * (bitDepth / 8);
      if (bitDepth === 32) {
        view.setFloat32(offset, data[i], true);
      } else {
        const sample = Math.max(-1, Math.min(1, data[i])) * 0x7fffff;
        view.setUint8(offset, (sample >> 0) & 0xff);
        view.setUint8(offset + 1, (sample >> 8) & 0xff);
        view.setUint8(offset + 2, (sample >> 16) & 0xff);
      }
    }
  }

  return new Blob([bufferArray], { type: "audio/wav" });
}
